module.exports = __webpack_public_path__ + "img/banklogo-10.265029e5.png";